<template>
  <div>
    <div ref="map" class="map"></div>
    <freeride-dialog ref='frDialog' />
  </div>
</template>
<script>
import Editmap from '../lib/Editmap'
import { deleteFeature, editFeature, newFeature } from '../lib/editFeatures';
import FreerideDialog from './dialogs/FreerideDialog.vue';
import { markRaw } from 'vue'
export default {
  components: { FreerideDialog },
  mounted() {
    fetch('/sh/auth/me').then(res => res.json())
    .then(res => {
      console.log('whoami: ', res);
      if (!res.name || /(Kranebitter|Öggl)/.test(res.name) === false) {
        this.$router.push('/map/login');
      }
    })
    this.emap = markRaw(new Editmap(this.$refs.map));
    this.emap.map.on('draw:created', (e) => {
      this.$refs.frDialog.open(e).then(res => {
        if (res.save) {
          newFeature(e, res.name, res.type).then(() => window.location.reload());
        }
      })
    });
    this.emap.map.on('draw:edited', async (e) => {
      const res = await editFeature(e);
      console.log('RES: ', res);
    });
    this.emap.map.on('draw:deleted', async (e) => {
      const res = await deleteFeature(e);
      console.log('RES: ', res);
      // window.location.reload();
    });
  },
  unmounted() {
    console.log('destroy component, incl. map:', this.emap.map);
    this.emap.map.remove();
  },
  data() {
    return {
      emap: markRaw({}),
    }
  },
}
</script>
<style lang="scss">
@import "../../node_modules/leaflet-draw/dist/leaflet.draw.css";

.leaflet-editing-icon {
  background-color: #f4f4f4;
  border: 1px solid #666;
  // border-radius: 50%;
  width: 10px !important;
  height: 10px !important;
  margin-top: -5px !important;
  margin-left: -5px !important;
  display: inline-block;
}

</style>